// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './stores'
import App from './App'
import router from './router'
import * as filters from './filters'
import '@/icons' // icon
import '@/styles/index.styl'
import '@/permission' // permission control
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/theme/theme/index.css' // element-ui主题
import '@/styles/quill.core.css'
import '@/styles/quill.snow.css'
import '@/styles/quill.bubble.css'
// 引入vue-lazyload
import VueLazyLoad from 'vue-lazyload'

import Flex from '@/components/Common//Flex.vue' // felx盒子
import MainDialog from '@/components/Common/MainDialog' // 公用弹窗组件
import MainTable from '@/components/MainTable/index' // 公用表格组件
import ToolBar from '@/components/Home/ToolBar.vue'
import FooterBox from '@/components/Home/FooterBox.vue'

import {
  Button,
  Cascader,
  Checkbox,
  CheckboxGroup,
  DatePicker,
  Dialog,
  Drawer,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Image,
  InfiniteScroll,
  Input,
  Loading,
  Message,
  MessageBox,
  Notification,
  Option,
  Pagination,
  Popover,
  Radio,
  RadioGroup,
  Select,
  Scrollbar,
  Step,
  Steps,
  Switch,
  Table,
  Tabs,
  TableColumn,
  Tag,
  TabPane,
  Tooltip,
  Tree,
  Upload,
  Progress
} from 'element-ui'

Vue.use(Button)
Vue.use(Cascader)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Drawer)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Image)
Vue.use(InfiniteScroll)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Select)
Vue.use(Scrollbar)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Switch)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(TableColumn)
Vue.use(Tag)
Vue.use(TabPane)
Vue.use(Tooltip)
Vue.use(Tree)
Vue.use(Upload)
Vue.use(Progress)

Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert

Vue.component('Flex', Flex)
Vue.component('MainDialog', MainDialog)
Vue.component('MainTable', MainTable)
Vue.component('ToolBar', ToolBar)
Vue.component('FooterBox', FooterBox)

Vue.use(VueLazyLoad, {
  loading: require('@/static/img/loading.gif')
})

Vue.config.productionTip = false
// 注册filter
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

/* eslint-disable no-new */
const vRouter = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  data: {
    eventHub: new Vue() // global event bus
  },
  template: '<App/>'
})

Vue.use({
  vRouter
})

export default vRouter
